import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { setThreadNotificationsMutation } from "@/app/Threads/GraphQL/threadMutations";

export function useSetThreadNotifications() {
  return useGqlMutation(setThreadNotificationsMutation);
}
